import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Card, Menu, Button, Dropdown, Modal } from 'antd';

const LogoutButton = () => {
    const { logout } = useAuth0();

    return (
        <a style={{ color: '#66615B'}} onClick={() => logout({ returnTo: window.location.origin })}>
            LOG OUT
        </a>
    );
};

export default LogoutButton;